import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {AuthenticationService} from '../../../services/authentication/authentication.service';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'app-confirm-mail-page',
    imports: [
        FormsModule,
        RouterLink
    ],
    templateUrl: './confirm-mail-page.component.html',
    styleUrl: './confirm-mail-page.component.sass'
})
export class ConfirmMailPageComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>()
    key: string = ''
    registerToken: string = ''
    message: string = 'Warten auf Bestätigung.'

    constructor(private activatedRoute: ActivatedRoute, private authenticationService: AuthenticationService) {
    }

    ngOnInit(): void {
        this.activatedRoute.params.subscribe(params => {
            this.key = params['uuid'];
            this.registerToken = params['registerToken'];
            if (this.key) {
                this.confirmMail();
            }
            if (this.registerToken) {
                this.confirmRegistration();
            }
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    confirmMail(): void {
        this.authenticationService.confirmMail(this.key)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: any) => {
                    this.message = 'Ihre E-Mail Adresse wurde erfolgreich bestätigt, Sie können sich nun Anmelden.'

                },
                error: (error) => {
                    console.error(error)
                }
            })
    }

    confirmRegistration(): void {
        this.authenticationService.confirmRegistration(this.registerToken)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: any) => {
                    this.message = 'Ihr Konto wurde erfolgreich verifiziert, Sie können sich nun Anmelden.'

                },
                error: (error) => {
                    console.error(error)
                }
            })
    }
}
